import React, { useContext, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import { numberFormat } from '../../../helpers/helperFunctions';
import useClientCallOutDashboard from '../context/useClientCallOutDashboard';

export default function ClientCallOutTable() {
  const { cncDashboard } = useContext(useClientCallOutDashboard);
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const handlePercentCellClassName = (value) => {
    let className;

    if (parseFloat(value) >= 101) {
      className = 'cell-super-green';
    }

    if (parseFloat(value) >= 90 && parseFloat(value) <= 100) {
      className = 'cell-green';
    }

    if (parseFloat(value) >= 80 && parseFloat(value) <= 89.9) {
      className = 'cell-yellow';
    }

    if (parseFloat(value) < 80) {
      className = 'cell-red';
    }

    return className;
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Admin',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'target',
      headerName: 'Target',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'actual',
      headerName: 'Actual',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => numberFormat(row.actual),
    },
    {
      field: 'total_percentage',
      headerName: '%',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      cellClassName: ({ row }) => handlePercentCellClassName(row.total_percentage),
      renderCell: ({ row }) => `${numberFormat(row.total_percentage)}%`,
    },
  ];

  const pinnedRows = {
    bottom: cncDashboard?.table?.length ? [cncDashboard?.table[0]] : [],
  };

  return (
    <Box
      className='table-container'
      sx={{
        height: `400px`,
        '& .super-app-theme--header': {
          backgroundColor: '#6B8D3E',
          color: '#fff',
        },
        '& .cell-green': {
          backgroundColor: '#ACE1AF',
          color: '#000',
          fontWeight: '600',
        },
        '& .cell-yellow': {
          backgroundColor: '#f0ad4e',
          color: '#000',
          fontWeight: '600',
        },
        '& .cell-red': {
          backgroundColor: '#FFADB0',
          color: '#000',
          fontWeight: '600',
        },
        '& .cell-super-green': {
          backgroundColor: '#5cb85c',
          color: '#000',
          fontWeight: '600',
        },
        '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#6B8D3E' },
      }}
    >
      <DataGridPro
        loading={cncDashboard?.loading}
        rows={cncDashboard?.table}
        columns={columns}
        sortModel={sortModel}
        experimentalFeatures={{ rowPinning: true }}
        initialState={{
          ...cncDashboard?.table.initialState,
          pagination: {
            pageSize: 50,
          },
        }}
        pinnedRows={pinnedRows}
        rowsPerPageOptions={[10, 25, 50]}
        pagination
        onSortModelChange={(model) => setSortModel(model)}
      />
    </Box>
  );
}
